import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e446673"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type-tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "square-content",
  ref: "contentRef"
}
const _hoisted_4 = {
  key: 0,
  class: "square-loading"
}
const _hoisted_5 = {
  key: 0,
  class: "star-list"
}
const _hoisted_6 = {
  key: 2,
  ref: "loadSentinelRef",
  class: "load-sentinel"
}
const _hoisted_7 = {
  key: 3,
  class: "loading-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_StrategyCard = _resolveComponent("StrategyCard")!
  const _component_StarNoData = _resolveComponent("StarNoData")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "starSquare" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "square-page",
        style: _normalizeStyle(_ctx.pageStyle)
      }, [
        _createVNode(_component_StarTabBar, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "square-header",
          style: _normalizeStyle({ background: _ctx.isLight ? '#f2f5fa' : _ctx.colors.bgPanel, borderBottom: _ctx.isLight ? '1px solid #dbdfe6' : 'none' })
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeTabs, (tab) => {
              return (_openBlock(), _createElementBlock("span", {
                key: tab.name,
                class: _normalizeClass(["type-tab", { active: _ctx.activeTypeName === tab.name }]),
                onClick: ($event: any) => (_ctx.switchType(tab.name))
              }, _toDisplayString(tab.name), 11, _hoisted_2))
            }), 128))
          ])
        ], 4),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_spin, { tip: "加载中..." })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.allList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allList, (item) => {
                        return (_openBlock(), _createBlock(_component_StrategyCard, {
                          key: item.id,
                          item: item,
                          source: "square"
                        }, null, 8, ["item"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_StarNoData, {
                      key: 1,
                      isDark: _ctx.isDark
                    }, null, 8, ["isDark"])),
                (_ctx.hasMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, null, 512))
                  : _createCommentVNode("", true),
                (_ctx.loadingMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_a_spin, { size: "small" })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 512)
      ], 4)
    ]),
    _: 1
  }))
}